import React from 'react';
import Dialogue from 'components/UI/Dialogue/Dialogue';

const TitleNeededDialogue = (props) => (
  <Dialogue
    subject="We're Sorry!"
    message="Your Draft couldn’t be saved. To save a Draft, you must add a Title."
    confirm={props.clicked}
    confirmationText="OK"
    postForm
  />
);

export default TitleNeededDialogue;
